import { Box, Card, Grid } from "@mui/material";
import PropTypes from "prop-types";

import InspectionTimeline from "modules/inspections/components/InspectionTimeline";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftButton from "components/SoftComponents/SoftButton";
import { useNavigate } from "react-router-dom";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { wrapper } from "utils/wrapper";
import { deviceViewWrapper } from "utils/wrapper";
import { useState } from "react";
import InspectionPreviewCard from "modules/inspections/components/InspectionPreviewCard";

import inspectionAPI from "modules/inspections/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";

function DeviceInspectionHistoryTab({ user, device, deviceLayout }) {

    const navigate = useNavigate();
    inspectionAPI.loadToken(useAuth0());

    const [adjustments, setAdjustments] = useState({
        search_by: '',
        sort_by: { value: 'date_desc', label: 'Date (Desc)' },
        filter_by: null,
        startTime: moment().subtract(3, 'year'),
        endTime: moment()
    });
    const [selectedInspection, setSelectedInspection] = useState(null);

    const onNewInspectionClick = () => {
        navigate(`/operations/new-inspection`, {
            state: {
                device
            }
        });
    }

    const inspections = useQuery({
        queryKey: ['getInspectionsByStopID', (device.stop?.stop_id ? device.stop.stop_id : device.stop.site_id)],
        queryFn: async () => {
            return await inspectionAPI.getInspectionsByStopID((device.stop?.stop_id ? device.stop.stop_id : device.stop.site_id));
        }
    });

    if (inspections.isLoading) {
        return wrapper('Loading...', deviceLayout);
    }

    if (inspections.error) {
        var error = inspections.error;
        return wrapper("An error has occurred: " + error.message, deviceLayout);
    }

    if (!inspections.data) {
        return wrapper('Loading...', deviceLayout);
    }

    const inspectionTimeline = (
        <Card sx={{ overflow: "visible", height: '100%' }}>
            <SoftBox m={1} mb={0}>
                <SoftBox display='flex' flexDirection='row' justifyContent='space-between'>
                    <Grid container>
                        <Grid item xxs={8}>
                            <SoftBox pl={0.5} display="flex" flexDirection="column" justifyContent="center" height="100%">
                                <SoftTypography variant="h5" fontWeight="bold">Device History</SoftTypography>
                            </SoftBox>
                        </Grid>
                        <Grid item xxs={4}>
                            <SoftBox display='flex' flexDirection='row' justifyContent={{ xxs: 'flex-end' }}>
                                <SoftButton variant='gradient' size="medium" color='dark' onClick={onNewInspectionClick}>
                                    {deviceLayout == "mobile" ? "New" : "New Inspection"}
                                </SoftButton>
                            </SoftBox>
                        </Grid>
                    </Grid>
                </SoftBox>
            </SoftBox>
            <SoftBox m={1} sx={{ overflowY: "hidden", borderRadius: "10px", height: "100%" }}>
                <InspectionTimeline selected_user={inspections.data.user} not_found_text={'History not found.'} inspections_data={inspections.data.inspections} {...{ selectedInspection, setSelectedInspection, adjustments, setAdjustments, deviceLayout }} />
            </SoftBox>
        </Card>
    );

    return (
        <>
            {deviceLayout == "mobile" ? (
                <SoftBox height={'unset'} minHeight={"calc(100svh - 9.5rem - 8px)"}>
                    {selectedInspection != null ? (
                        <Box /*p={1} sx={{ height: 'calc(100% - 16px)' }}*/>
                            <InspectionPreviewCard {...{ selectedInspection, setSelectedInspection, user, deviceLayout }} />
                        </Box>
                    ) : (
                        inspectionTimeline
                    )}
                </SoftBox>
            ) : (
                deviceViewWrapper(
                    inspectionTimeline,
                    (
                        <SoftBox height={"calc(100svh - 10.25rem - 16px)"}>
                            <InspectionPreviewCard {...{ selectedInspection, setSelectedInspection, user, deviceLayout }} />
                        </SoftBox>
                    ),
                    deviceLayout
                )
            )}
        </>
    );
}

DeviceInspectionHistoryTab.propTypes = {
    user: PropTypes.object,
    device: PropTypes.object,
    deviceLayout: PropTypes.string
}

export default DeviceInspectionHistoryTab;